import CourseActions from 'modules/courses/bundles/course-bundle/components/course-actions'
import {
  CourseBundleInterface,
  CourseBundleItemInterface,
} from 'modules/courses/bundles/course-bundle/types/course-bundle-interface'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { KeyedMutator } from 'swr'

interface CourseProps {
  item?: CourseBundleItemInterface
  mutate: KeyedMutator<CourseBundleInterface>
}

function CourseOverlay({ item, mutate }: CourseProps) {
  const { t } = useLocoTranslation()

  if (!item) {
    return null
  }

  return (
    <div className="hover:border-brand-primary main-transition-colors even:bg-brand-primary-subtle odd:bg-background-secondary flex cursor-move flex-col gap-3 border border-transparent first:rounded-t-lg last:rounded-b-lg focus-visible:outline-hidden">
      <div className="z-0 overflow-hidden rounded-lg">
        <div className="flex flex-col overflow-hidden rounded-b-lg lg:flex-row lg:items-center">
          <div className="text-text-primary text-start flex-[65_1_0%] truncate px-4 py-2 text-base lg:px-6 lg:py-4">
            <div className="relative flex h-full w-full max-w-fit cursor-pointer items-center gap-2 truncate text-base">
              <span className="truncate ">{item.course.name}</span>
            </div>
          </div>
          <div className="text-text-primary text-start flex-[25_1_0%] truncate px-4 py-2 text-base lg:px-6 lg:py-4">
            <div>
              <div className="relative flex h-full w-full max-w-fit items-center truncate">
                <span className="cursor-default truncate">
                  {t('dashboard.course_bundle.course.delay_title')} {item.delayBeforeStart || 0}
                </span>
              </div>
            </div>
          </div>
          <div className="text-text-primary font-inter flex-[10_1_0%] truncate px-4 py-2 text-[17px] font-bold lg:px-6 lg:py-4">
            <CourseActions item={item} mutate={mutate} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseOverlay
